import React, { useContext } from 'react';
import { languageContext } from 'contexts/language_context/LanguageContext';
import { themeContext } from 'contexts/theme_context/ThemeContext';
import './LanguageButton.css'; // Assuming styles are separated into a CSS file

const LanguageButton = () => {
  const { weblanguage, changelanguageTo } = useContext(languageContext);
  const { webtheme } = useContext(themeContext);

  const toggleLanguage = () => {
    const newLanguage = weblanguage === 'ar' ? 'en' : 'ar';
    changelanguageTo(newLanguage);
  };

  const iconClass = `fas fa-globe fs-7 ${webtheme}-text ${weblanguage === 'ar' ? 'order-2' : 'order-1'}`;

  return (
    <div className="language-button d-flex align-items-center h-100 mx-2 cursor" onClick={toggleLanguage}>
      <i className={iconClass}></i>
    </div>
  );
};

export default LanguageButton;
